import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import {
  FormControlLabel,
  FormGroup,
  TextField,
  Typography,
  FormControl,
  Radio,
  RadioGroup,
  InputAdornment,
} from "@mui/material";
import "./css/InverterSelectorForm.css";
import { Card, CardHeader, CardContent } from "@mui/material";

export class BatterySelectView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalcap4IS: "",
      phase4IS: "",
      inputVolt4IS: "",
      showCustomBP: this.props.batBUTData === "Custom" ? true : false,
    };
  }

  onBatBackupTime = (event) => {
    if (event.target.value === "90") {
      console.log("90 minutes bp time");
      this.setState({ showCustomBP: false });
      //Call the func and save data as 90
      this.props.setbatBUTData("90");
    } else if (event.target.value === "120") {
      console.log("120 minutes bp time");
      this.setState({ showCustomBP: false });
      //Call the func and save data as 120
      this.props.setbatBUTData("120");
    } else {
      console.log("custom");
      this.setState({ showCustomBP: true });
      //do nothing and wait for" textfield func
      this.props.setbatBUTData("Custom");
    }
  };

  customBatBUT = (event) => {
    //call the func
    this.props.setCustombatBUTData(event.target.value);
  };

  setBatteryType = (event) => {
    this.props.setbatTypeData(event.target.value);
  };

  render() {
    return (
      //App starts here
      <Card elevation={10}>
        <CardHeader
          titleTypographyProps={{
            fontFamily: "Ford-Normal",
          }}
          className="paperh-title"
          title="Batteries"
        />
        <CardContent className="bv-cardContent">
          <Paper className="bv-Paper" elevation={5}>
            <FormGroup>
              <FormControl>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  name="radio-buttons-group"
                  onChange={this.onBatBackupTime}
                  defaultValue={
                    this.props.batBUTData === "" ? "90" : this.props.batBUTData
                  }
                  sx={{
                    "& .MuiTypography-root": { fontFamily: "Ford-Normal" },
                  }}
                >
                  <FormControlLabel
                    value="90"
                    control={<Radio />}
                    label="90 Minutes"
                  />
                  {this.props.data.productType !== "Mini Power Wave" &&
                    this.props.data.productType !== "Micro Power Wave" && (
                      <FormControlLabel
                        value="120"
                        control={<Radio />}
                        label="120 Minutes"
                      />
                    )}
                  {this.props.data.productType !== "Mini Power Wave" &&
                    this.props.data.productType !== "Micro Power Wave" && (
                      <FormControlLabel
                        value="Custom"
                        control={
                          <Radio
                            hidden={
                              this.props.data.productType === "Mini Power Wave"
                            }
                          />
                        }
                        label="Custom"
                      />
                    )}
                </RadioGroup>
              </FormControl>
              {this.props.data.productType !== "Mini Power Wave" &&
                this.props.data.productType !== "Micro Power Wave" && (
                  <TextField
                    InputLabelProps={{ style: { fontFamily: "ford-family" } }} // font size of input label
                    disabled={!this.state.showCustomBP}
                    defaultValue={this.props.custombatBUTData}
                    onChange={this.customBatBUT}
                    variant="outlined"
                    helperText="Add your desired Minutes for Back up"
                    sx={{
                      m: 1,
                      width: "50%",
                      "& input": { textAlign: "end" },
                      "& .MuiTypography-root": { fontFamily: "Ford-Normal" },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">Minutes</InputAdornment>
                      ),
                    }}
                  />
                )}
            </FormGroup>
          </Paper>
          <Paper className="bv-Paper" elevation={5}>
            <Typography style={{ fontFamily: "Ford-Normal" }}>
              {" "}
              Select Battery Type{" "}
            </Typography>
            <RadioGroup
              aria-labelledby="demo-radio-buttons-group-label"
              name="radio-buttons-group"
              onChange={this.setBatteryType}
              defaultValue={
                this.props.batTypeData === ""
                  ? this.props.data.productType === "Micro Power Wave"
                    ? "Standard"
                    : "Standard"
                  : this.props.batTypeData
              }
              sx={{ "& .MuiTypography-root": { fontFamily: "Ford-Normal" } }}
            >
              {
                <FormControlLabel
                  value="Standard"
                  control={<Radio />}
                  label="Standard Top Terminal"
                />
              }
              {this.props.data.productType !== "Micro Power Wave" &&
                this.props.data.productType !== "Mini Power Wave" && (
                  <FormControlLabel
                    value="Long Life"
                    control={<Radio sx={{ fontFamily: "Ford-Normal" }} />}
                    label="Long Life"
                  />
                )}
              {this.props.data.productType !== "Mini Power Wave" &&
                this.props.data.productType !== "Micro Power Wave" && (
                  <FormControlLabel
                    value="High Temp"
                    control={<Radio />}
                    label="High Temperture"
                  />
                )}
              {
                <FormControlLabel
                  value="USA"
                  control={<Radio />}
                  label="USA Made Batteries (Meets BAA & BABA Compliance)"
                />
              }
            </RadioGroup>
          </Paper>
        </CardContent>
      </Card>
    );
  }
}

export default BatterySelectView;
